export default __webpack_public_path__ + "media/zurb/img/work/iqtell-thumb2-3d574ec63020efae57d21e00dbc2cff8.png";